import { Integer } from "@type-r/ext-types";
import { AttributesMixin, define, Model } from "@type-r/models";

@define 
export class Source extends Model {
    static attributes = {
        name : String,
        assetType : String,
        unresolvedAssets : Integer
    }
}

export interface Source extends AttributesMixin<typeof Source>{}
